import { Box, Flex, Grid } from '@chakra-ui/react';
import { CompaRatio } from '@mesh.ai/rabbit';

import { Calendar } from 'assets/assetsV1/iconComponents';

import { DatePicker } from 'uiToolkitV1/DatePicker';
import { InputV2 } from 'uiToolkitV1/InputV2';
import { SalaryPercentageInput } from 'uiToolkitV1/SalaryPercentageInput';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const compensationData = [
  {
    id: 1,
    roleName: 'Shift Manager',
    currentPay: {
      value: 18.0,
      display: '$18.00/hr',
    },
    compaRatio: 70,
    proposedPay: {
      baseValue: 19.33,
      initialValue: 20.4,
      currencySymbol: '$',
      unitSuffix: '/hr',
    },
    guidelines: {
      min: 5,
      max: 7,
    },
  },
  {
    id: 2,
    roleName: 'Cashier',
    currentPay: {
      value: 18.0,
      display: '$18.00/hr',
    },
    compaRatio: 70,
    proposedPay: {
      baseValue: 19.33,
      initialValue: 20.4,
      currencySymbol: '$',
      unitSuffix: '/hr',
    },
    guidelines: {
      min: 5,
      max: 7,
    },
  },
  {
    id: 3,
    roleName: 'Kitchen staff',
    currentPay: {
      value: 18.0,
      display: '$18.00/hr',
    },
    compaRatio: 70,
    proposedPay: {
      baseValue: 19.33,
      initialValue: 20.4,
      currencySymbol: '$',
      unitSuffix: '/hr',
    },
    guidelines: {
      min: 5,
      max: 7,
    },
  },
];

type CompensationDetailsProps = {
  headerText?: string;
  isBottomSheet?: boolean;
};

export const CompensationDetails = ({
  headerText = 'Compensation details for Sarah Johnson',
  isBottomSheet = false,
}: CompensationDetailsProps) => (
  <Flex flexDir="column" bg="white" p="12px" borderRadius="8px" gap="12px">
    <Flex pb="8px" borderBottom="1px solid" borderColor="#E7E7E7">
      <TextBodyMedium bold>{headerText}</TextBodyMedium>
    </Flex>
    {compensationData.map((role) => (
      <Flex key={role.id} flexDir="column" gap="8px">
        <TextLabel bold color="text.g1">
          {role.roleName}
        </TextLabel>
        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            desktop: isBottomSheet ? 'repeat(2, 1fr)' : 'repeat(3, 200px)',
          }}
          gap="40px"
          py="8px"
          gridRowGap={{ base: '18px', desktop: isBottomSheet ? '18px' : '40px' }}
        >
          <Flex flexDir="column" gap="14px">
            <TextLabel color="text.g2">Current pay</TextLabel>
            <TextBodyMedium>{role.currentPay.display}</TextBodyMedium>
          </Flex>
          <Flex flexDir="column" gap="12px">
            <TextLabel color="text.g2">Compa ratio</TextLabel>
            <Flex gap="8px">
              <CompaRatio value={role.compaRatio} width={148} />
              <TextBodyMedium bold>{role.compaRatio}%</TextBodyMedium>
            </Flex>
          </Flex>
          <Flex flexDir="column">
            <TextLabel color="text.g2">Proposed pay</TextLabel>
            <SalaryPercentageInput
              baseValue={role.proposedPay.baseValue}
              initialValue={role.proposedPay.initialValue}
              currencySymbol={role.proposedPay.currencySymbol}
              unitSuffix={role.proposedPay.unitSuffix}
              guidelineMin={role.guidelines.min}
              guidelineMax={role.guidelines.max}
            />
          </Flex>
        </Grid>
      </Flex>
    ))}
    <Flex flexDir="column" gap="16px">
      <Flex flexDir="column" gap="4px" pt="12px">
        <TextLabel>Effective date</TextLabel>
        <Box py="10px">
          <DatePicker
            selectedDate={new Date()}
            onChange={() => {}}
            customInputProps={{
              width: '160px',
              justifyContent: 'space-between !important',
              StartIcon: null,
              EndIcon: Calendar,
            }}
          />
        </Box>
      </Flex>
      <Flex flexDir="column" gap="12px">
        <TextLabel color="text.g2">Comments (Optional)</TextLabel>
        <Box pb="24px">
          <InputV2 placeholder="Enter comments" pb="32px !important" />
        </Box>
      </Flex>
    </Flex>
  </Flex>
);
